if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });


    $("a.btn").append("<span></span>");
    $("a.btn2").append("<span></span>");
    $("a.btn-white").append("<span></span>");
    setTimeout(function(){
        $("a.learn-more-btn").append("<span></span>");
    },500)
    
    

    const acc_btns = document.querySelectorAll('.accordion__button');
    const acc_items = document.querySelectorAll('.accordion__item');
    if(acc_btns){
        for(let i = 0; i < acc_btns.length; i++){
            acc_btns[i].addEventListener('click', function(){
                if(this.closest('.accordion__item').classList.contains('active')){
                    this.closest('.accordion__item').classList.remove('active');
                }else{
                    // for(let a = 0; a < acc_items.length; a++){
                    //     acc_items[a].classList.remove('active');
                    // }
                    this.closest('.accordion__item').classList.add('active');
                }
            })
        } 
    }

    // $( ".form-module-wrapper .form-module__confirmation, .form-module-wrapper form").wrapAll( "<div class='form-module-wrapper__container animate-fade top'></div>" )

    $('.close-menu').click(function(){
        $('.navigation.overlay').removeClass('show');
    });

    $('#menu-btn').click(function(){
        $('.navigation.overlay').addClass('show');
    });

    if($('.gallery-home-m__slider').length > 0){
        $('.gallery-home-m__slider').slick({
            accessibility: true,
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 7000,
            speed: 700,
            centerMode: true,
            slideToShow: 1,
        });
    }

    $('[data-fancybox]').fancybox({
        loop: false
    });

    
    if($('.hours__slider').length > 0){
        $('.hours__slider').slick({
            accessibility: true,
            arrows: false,
            dots: true,
            autoplay: true,
            fade: true,
            autoplaySpeed: 7000,
            speed: 700
        });
    }


})();